import { render, staticRenderFns } from "./PopularSportsFilter.vue?vue&type=template&id=32b8c990&"
import script from "./PopularSportsFilter.vue?vue&type=script&lang=js&"
export * from "./PopularSportsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports